module.exports = __webpack_public_path__ + "img/globeicon.66ea2b75.svg";